import React from 'react';
import LegalDocument from '../components/LegalDocument';

const RefundPolicy = () => {
  return <LegalDocument type="refund" />;
};

export default RefundPolicy;
